import { CousrsDetailsType } from "@/app/types";
import { useTranslations } from "next-intl";
import Image from "next/image";

const MainInformation = ({ course }: { course: CousrsDetailsType }) => {
  const t = useTranslations("courses");

  return (
    <div>
      {" "}
      <div className="flex w-fit relative max-sm:max-w-[300px] gap-[17px] lg:max-w-[920px]  items-center  lg:gap-4  mb-4">
        {course?.courseIconUrl && (
          <Image
            alt={`Icon for ${course?.name}`}
            src={course?.courseIconUrl}
            width={35}
            height={35}
            className="w-[35.72px]   object-contain h-[35.72px] lg:h-[5.45rem] lg:w-[5.45rem]"
          />
        )}
        <h1 className="lg:text-[3.75rem] relative text-[28px] font-bold">
          <p className="absolute whitespace-nowrap start-0 lg:-top-5 -top-9 lg:text-[1.5rem] font-medium text-[16px]">
            {t("youAreEnrollingTo")}
          </p>
          {course.name}
        </h1>
        <div
          className="absolute  lg:h-[30px] end-0 bottom-[-27px] text-white lg:text-[1.25rem] flex justify-center items-center text-[12px] px-4 h-[22px] w-fit"
          style={{ background: course?.color }}
        >
          {t("age")} <span className="">{course?.ageRange}</span>
        </div>
      </div>
    </div>
  );
};
export default MainInformation;
